import { formatDateMontDayYearTime } from "../../../../../../utils";
import { BaseText } from "../../../../../../components";
import { FieldsAndApprovalDecisions } from "./ApprovalFlowForm";
interface StageHasDecisionViewProps {
	userBadgeClassNames: string;
	selectedStage: FieldsAndApprovalDecisions;
}

const StageHasDecisionView: React.FC<StageHasDecisionViewProps> = ({
	selectedStage,
	userBadgeClassNames,
}) => {
 	return (
		<>
			<div className="flex flex-col gap-y-6">
				{selectedStage?.inputs?.map((input: any) => {
					return input.valueKey === "assignedTo" ? (
						<div className="w-full flex flex-col gap-y-3 ">
							<dl>
								<dt className="font-omnes-medium">
									{input.label}
								</dt>
								<div
									className={`flex items-center justify-between w-full font-omnes-regular`}
								>
									<div
										className={`flex text-left p-1 pr-2 py-2 text-sm border-1 rounded h-[38px bg-navy-200 ${input.inputContainerWidth} hover:cursor-not-allowed`}
									>
										<dd className="text-navy-500">
											{selectedStage.assignedUser?.name ||
											selectedStage.assignedUser?.email
												? `${selectedStage.assignedUser.name || ""} ${selectedStage.assignedUser?.email ? `(${selectedStage.assignedUser.email})` : ""}`.trim()
												: "—"}
										</dd>
									</div>
								</div>
							</dl>

							<div className="font-omnes-regular">
								<span className="text-sm">
									Eligible Approvers:{" "}
								</span>

								{selectedStage.allowedRoles.length > 0 &&
									selectedStage.allowedRoles.map(
										(role: string) => (
											<span
												key={role}
												className={userBadgeClassNames}
											>
												{role}
											</span>
										),
									)}
							</div>
						</div>
					) : (
						<div className="w-full flex flex-col gap-y-3">
							<dl>
								<dt className="font-omnes-medium">
									{input.label}
								</dt>
								<div
									className={`flex items-center justify-between w-full font-omnes-regular`}
								>
									<div
										className={`flex text-left p-1 pr-2 py-2 text-sm border-1 rounded h-[160px] bg-navy-200 ${input.inputContainerWidth} hover:cursor-not-allowed`}
									>
										<dd className="text-navy-500">{`${selectedStage.decision.note || "—"}`}</dd>
									</div>
								</div>
							</dl>
						</div>
					);
				})}
			</div>
		</>
	);
};

export default StageHasDecisionView;
